import { AlertIcon, ActionIcon, InfoIcon, WarningIcon } from '../Icons/NoficationsTypesIcons/NotificationTypeIcons';
import { NOTIFICATION_TYPES } from './NotificationTypes';

export const NOTIFICATION_ICONS = {
    [NOTIFICATION_TYPES.ACTION]: ActionIcon,
    [NOTIFICATION_TYPES.WARNING]: WarningIcon,
    [NOTIFICATION_TYPES.INFORMATION]: InfoIcon,
    [NOTIFICATION_TYPES.ALERT]: AlertIcon,
};
